import { compose, withProps } from 'recompose';
import ObjectInput from '@/se/components/inputs/ObjectInput';

import PatientCapacityInput from '../patient/PatientCapacityInput';
import ToggleInput from '@/se/components/inputs/ToogleInput';
import { withLabel } from '@/se/components/Label';
import NumberInput from '@/se/components/inputs/NumberInput';

export default withProps({
  schema: {
    capacity: PatientCapacityInput,
    isAlphabeticBedOrder: withProps({ label: 'The beds are marked with letters in alphabetical order' })(ToggleInput),
    isHideInternalScreen: withProps({ label: 'Hide room on Internal screen' })(ToggleInput),
    isHideScheduleScreen: withProps({ label: 'Hide room on Schedule screen' })(ToggleInput),
    isHideLiaisonScreen: withProps({ label: 'Hide room on Liaison screen' })(ToggleInput),
    oobWarningThreshold: compose(
      withLabel('OoB Warning Threshold'),
      withProps({ placeholder: 'e.g., 20' })
    )(NumberInput),
    ptWarningThreshold: compose(withLabel('PT Warning Threshold'), withProps({ placeholder: 'e.g., 20' }))(NumberInput),
    ptCompleteWarningThreshold: compose(
      withLabel('PT Complete Warning Threshold'),
      withProps({ placeholder: 'e.g., 20' })
    )(NumberInput),
    pacuOutWarningThreshold: compose(
      withLabel('PACU Out Warning Threshold'),
      withProps({ placeholder: 'e.g., 20' })
    )(NumberInput),
  },
})(ObjectInput);
